/**
 * An investment in USD as whole thousands with dots between thousands ("15.000" for 15 million),
 * or null when the amount is not identified.
 */
export const formatThousandsUSD = (value?: number | string | null): string | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const thousands = Math.round(Number(value) / 1000);
  return thousands.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * A total in USD as millions with up to two decimals, Spanish style ("$ 13.895,84"), or null when
 * there is no total.
 */
export const formatMillionsUSD = (value?: number | string | null): string | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const [whole, decimals] = (Math.round(Number(value) / 10000) / 100).toFixed(2).split('.');
  const shownDecimals = decimals.replace(/0+$/, '');
  return `$ ${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${shownDecimals ? `,${shownDecimals}` : ''}`;
};
